import type { EventType } from '../types'

export const typeMeta: Record<
  EventType,
  { icon: string; bg: string; border: string; iconBg: string; label: string; dot: string }
> = {
  general: { icon: '📌', bg: 'bg-slate-50', border: 'border-slate-200', iconBg: 'bg-slate-100', label: 'No type', dot: 'bg-slate-400' },
  shift: { icon: '👥', bg: 'bg-brand-50', border: 'border-brand-100', iconBg: 'bg-brand-100', label: 'Support Shift', dot: 'bg-brand-500' },
  appointment: { icon: '🩺', bg: 'bg-emerald-50', border: 'border-emerald-100', iconBg: 'bg-emerald-100', label: 'Appointment', dot: 'bg-emerald-500' },
  meeting: { icon: '📋', bg: 'bg-amber-50', border: 'border-amber-100', iconBg: 'bg-amber-100', label: 'Meeting', dot: 'bg-amber-500' },
}

